import SignInForm from "../../components/views/sign-in";

function SignInPage() {

  return <SignInForm />
}

export default SignInPage;
